// // Code review - In Progress
// // Documentation - In Progress
// import React, { useEffect, useState } from "react";
// import { mainTable } from "../css/Common";
// import MultiSelect from "../ReusableComponents/MultiSelect";
// import { BindAPI } from "../services/APIConnection";
// import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
// import pdf from "../image/pdf.png";
// import word from "../image/word_icon.png";
// import excel from "../image/xls_icon.png";
// import ppt from "../image/ppt_icon.png";
// import download from "../image/download.png";

// const AssessmentReportPopup = ({ data }) => {
//   const [showFileModal, setShowFileModal] = useState(false);
//   const [selectedFileUrl, setSelectedFileUrl] = useState("");
//   const [assessmentReportFields, setAssessmentReportFields] = useState({
//     company: [],
//     valueChainPartner: "",
//     date: "",
//     showImage: "",
//   });
//   const [assessmentReportFieldsError, setAssessmentReportFieldsError] =
//     useState({
//       companyError: "",
//       valueChainPartnerError: "",
//       showImageError: "",
//     });
//   // Bind Dropdown Values
//   const [bindCompanyDatas, setCompanyDatas] = useState([]);
//   const [bindChainPartnerDatas, setChainPartnerDatas] = useState([]);
//   const handleAssessmentReportFieldsChange = (value, name) => {
//     setAssessmentReportFields({
//       ...assessmentReportFields,
//       [name]: value,
//     });
//   };
//   const getFileIcon = (url) => {
//       const ext = url?.split(".").pop()?.toLowerCase();
//       switch (ext) {
//         case "pdf":
//           return pdf;
//         case "doc":
//         case "docx":
//           return word;
//         case "xls":
//         case "xlsx":
//           return excel;
//         case "ppt":
//         case "pptx":
//           return ppt; // ✅ return PowerPoint icon
//         default:
//           return isImageFile(url) ? url : download;
//       }
//     };
//   const isImageFile = (url) => {
//     const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg"];
//     const ext = url?.split(".").pop()?.toLowerCase();
//     return imageExtensions.includes(ext);
//   };
//   const getViewerUrl = (url) => {
//     if (!url) return "";
//     const extension = url.split(".").pop().toLowerCase();

//     return extension === "pdf"
//       ? url
//       : `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
//           url
//         )}`;
//   };
//   // Selected Dropdown Values

//   useEffect(() => {
//     const BindCompanyAndChainPartnerDropdown = async () => {
//       const bindReferredBydatadrp = await BindAPI("PartnerAPI/BindPartner");

//       const filteredData = bindReferredBydatadrp.data.Table;
//       const filteredWithInActivatedByNull = filteredData.filter(
//         (item) => item.Status === "Active"
//       );
//       const filteredWithTypeC = filteredWithInActivatedByNull.filter(
//         (item) => item.Type === "C"
//       );
//       const filteredWithTypeVCP = filteredWithInActivatedByNull.filter(
//         (item) => item.Type === "VCP"
//       );

//       bindCompanyData(filteredWithTypeC);
//       bindChainPartnerData(filteredWithTypeVCP);
//     };
//     BindCompanyAndChainPartnerDropdown();
//   }, []);

//   const bindCompanyData = async (resultdata) => {
//     try {
//       if (resultdata.length > 0) {
//         const CompanyAndChainPartnerDD = resultdata.map((m) => ({
//           value: m.MstPartnerId,
//           label: `${m.PartnerName} ${m.Type}`,
//         }));
//         setCompanyDatas(CompanyAndChainPartnerDD);
//       } else {
//         setCompanyDatas([]);
//       }
//     } catch (error) {
//       console.error("Error fetching CompanyAndChainPartner data:", error);
//     }
//   };
//   const bindChainPartnerData = async (resultdata) => {
//     try {
//       if (resultdata.length > 0) {
//         const CompanyAndChainPartnerDD = resultdata.map((m) => ({
//           value: m.MstPartnerId,
//           label: `${m.PartnerName} ${m.Type}`,
//         }));
//         setChainPartnerDatas(CompanyAndChainPartnerDD);
//       } else {
//         setChainPartnerDatas([]);
//       }
//     } catch (error) {
//       console.error("Error fetching CompanyAndChainPartner data:", error);
//     }
//   };

//   useEffect(() => {
//     if (!data || !data.MstCompanyIds || !data.MstValueChainPartnerId) return;

//     const CompanyIds = data.MstCompanyIds.split(",");
//     const matchedCompany = bindCompanyDatas.filter((item) =>
//       CompanyIds.includes(String(item.value))
//     );

//     var customerDate = data.Date;
//     const customerDatePart = customerDate.split("T")[0];
//     setAssessmentReportFields({
//       ...assessmentReportFields,
//       company: matchedCompany || [],
//       valueChainPartner: data.MstValueChainPartnerId,
//       date: customerDatePart,
//     });
//   }, [data]);

//   const customerChange1 = (updatedOptions) => {
//     const selectedItems = bindCompanyDatas.filter((item) =>
//       updatedOptions.includes(item.value)
//     );
//     setAssessmentReportFields((prevFields) => ({
//       ...prevFields,
//       company: selectedItems,
//     }));
//   };
//   const handleShowImage = (showImage) => {
//     setAssessmentReportFields({
//       ...assessmentReportFields,
//       showImage: showImage || "",
//     });

//     setAssessmentReportFieldsError({
//       ...assessmentReportFieldsError,
//       showImageError: "",
//     });
//   };
//   return (
//     <div class="w-full">
//       <div class={mainTable.mainContentScreen}>
//         <form class="overflow-auto p-5 lg:h-96 md:min-h-[60vh] md:max-h-[60vh] min-h-fit max-h-fit sm:min-h-fit  sm:max-h-fit">
//           <div className="flex justify-center">
//             <div className="w-3/4">
//               <div class="grid gap-4 mb-2 md:grid-cols-2">
//                 <AutoDropDown
//                   title="Value Chain Partner"
//                   disabled={true}
//                   options={bindChainPartnerDatas}
//                   placeholder="Select"
//                   name="valueChainPartner"
//                   selectedOption={
//                     assessmentReportFields.valueChainPartner
//                       ? bindChainPartnerDatas.find(
//                           (x) =>
//                             x.value == assessmentReportFields.valueChainPartner
//                         )
//                       : ""
//                   }
//                   Class="custom-class"
//                   tabIndex="1"
//                   classStar="text-red-500"
//                   controlFunc={(value, e) => {
//                     handleAssessmentReportFieldsChange(value.value, e.name);
//                   }}
//                   controlFuncBlur={() => {
//                     setAssessmentReportFieldsError(() => ({
//                       ...assessmentReportFieldsError,
//                       valueChainPartnerError:
//                         assessmentReportFields.valueChainPartner
//                           ? ""
//                           : "Select Value Chain Partner",
//                     }));
//                   }}
//                   errorMessage={
//                     assessmentReportFieldsError.valueChainPartnerError
//                   }
//                 />
//                 <div>
//                   <MultiSelect
//                     classStar="text-red-500"
//                     label="Company"
//                     disabled={true}
//                     dropDownDisabled={true}
//                     filteredOptions={bindCompanyDatas}
//                     classFilterLabel="p-1 flex gap-1"
//                     class="custom-class"
//                     placeholder={
//                       assessmentReportFields.company?.length > 0
//                         ? "More Selected"
//                         : "Select..."
//                     }
//                     name="Company"
//                     selectedOptions={
//                       assessmentReportFields.company
//                         ? assessmentReportFields.company.map(
//                             (item) => item.value
//                           )
//                         : ""
//                     }
//                     classDiv="relative w-full inline-block"
//                     onChange={customerChange1}
//                     classLabel={mainTable.labelNoWrap}
//                   />
//                   {assessmentReportFieldsError.companyError && (
//                     <span className="text-red-500">
//                       {assessmentReportFieldsError.companyError}
//                     </span>
//                   )}

//                   {assessmentReportFields.company?.length > 0 && (
//                     <div className="mt-2">
//                       <div className="flex flex-col gap-2">
//                         {assessmentReportFields.company.map((item, index) => (
//                           <span
//                             key={index}
//                             className="bg-gray-100 px-2 py-1 w-fit rounded text-sm text-gray-800"
//                           >
//                             {item.label}
//                           </span>
//                         ))}
//                       </div>
//                     </div>
//                   )}
//                 </div>
//                 <div class="grid gap-4 mb-2 md:grid-cols-2">
//                   <img
//                     src={getFileIcon(data?.AttachmentFile)}
//                     alt="Payment"
//                     onClick={() => {
//                       setSelectedFileUrl(data?.AttachmentFile);
//                       setShowFileModal(true);
//                     }}
//                   />
//                 </div>
//                 {showFileModal && (
//                   <div
//                     className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
//                     onClick={() => setShowFileModal(false)} // Outside click closes modal
//                   >
//                     <div
//                       className="bg-white p-6 rounded shadow-lg max-w-4xl w-full h-full relative"
//                       onClick={(e) => e.stopPropagation()} // Prevent close on inside click
//                     >
//                       <button
//                         onClick={() => setShowFileModal(false)}
//                         className="absolute top-2 right-2 text-gray-500 hover:text-black text-xl"
//                       >
//                         ✕
//                       </button>
//                       {selectedFileUrl ? (
//                         isImageFile(selectedFileUrl) ? (
//                           <img
//                             src={selectedFileUrl}
//                             alt="Preview"
//                             className="w-full h-full object-contain rounded"
//                           />
//                         ) : (
//                           <iframe
//                             src={getViewerUrl(selectedFileUrl)}
//                             title="File Viewer"
//                             className="w-full h-[80vh] rounded"
//                           />
//                         )
//                       ) : (
//                         <div className="text-center text-gray-500">
//                           No file selected
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 )}
//               </div>
//               {/* <FileUpload
//                 title="Attach ESG attachment report"
//                 apiCall="AssessmentReportAPI/AssessmentReportImageUpload"
//                 modalName="AttachmentFile"
//                 name="showImage"
//                 classStar="text-red-500"
//                 class="custom-class"
//                 disabledBtn={true}
//                 showImage={assessmentReportFields.showImage}
//                 showImageData={handleShowImage}
//                 imageUploadedError={assessmentReportFieldsError.showImageError}
//                 imageShow={false}

//                 MAX_FILE_SIZE_MB={100}
//                 ALLOWED_FORMATS={[
//                   "image/jpeg",
//                   "image/jpg",
//                   "image/png",
//                   "application/pdf", // for PDFs
//                   "application/msword", // for .doc files
//                   "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
//                 ]}
//               /> */}
//             </div>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default AssessmentReportPopup;
import { useEffect, useState } from "react";
import pdfIcon from "../image/pdf.png";
import wordIcon from "../image/word_icon.png";
import excelIcon from "../image/xls_icon.png";
import pptIcon from "../image/ppt_icon.png"; // ✅ Add your PPT icon
import { mainTable } from "../css/Common";
import { BindAPI } from "../services/APIConnection";

const AssessmentReportPopup = ({ data, data2 }) => {
  
  const [previewUrl, setPreviewUrl] = useState(null);
  const [showFileModal, setShowFileModal] = useState(false);
  const [disabledBtn, setDisabledBtn] = useState(false);

  const fileUrl = data?.AttachmentFile;
  const fileExtension = fileUrl?.split(".").pop()?.toLowerCase();

  const isImage = ["png", "jpg", "jpeg", "gif", "webp"].includes(fileExtension);
  const isPdf = fileExtension === "pdf";
  const isWord = ["doc", "docx"].includes(fileExtension);
  const isExcel = ["xls", "xlsx"].includes(fileExtension);
  const isPPT = ["ppt", "pptx"].includes(fileExtension); // ✅ PPT check

  const handlePreview = () => {
    setPreviewUrl(fileUrl);
    setShowFileModal(true);
  };

  const getViewerUrl = (url) => {
    if (!url) return "";
    const ext = url.split(".").pop().toLowerCase();
    const officeExt = ["doc", "docx", "ppt", "pptx", "xls", "xlsx"];
    if (ext === "pdf") return url;
    if (officeExt.includes(ext)) {
      return `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(url)}`;
    }
    return "";
  };

  useEffect(() => {
    setPreviewUrl(null);
    setShowFileModal(false);
  }, [data]);

  const renderFilePreview = () => {
    if (isImage) {
      return <img src={fileUrl} alt="Attachment" className="w-16 h-16 border rounded" />;
    } else if (isPdf) {
      return (
        <div className="cursor-pointer w-16" onClick={handlePreview}>
          <img src={pdfIcon} alt="PDF" />
        </div>
      );
    } else if (isWord) {
      return (
        <div className="cursor-pointer w-16" onClick={handlePreview}>
          <img src={wordIcon} alt="Word Document" />
        </div>
      );
    } else if (isExcel) {
      return (
        <div className="cursor-pointer w-16" onClick={handlePreview}>
          <img src={excelIcon} alt="Excel Document" />
        </div>
      );
    } else if (isPPT) {
      return (
        <div className="cursor-pointer w-16" onClick={handlePreview}>
          <img src={pptIcon} alt="PowerPoint Document" />
        </div>
      );
    } else {
      return <span className="text-gray-500">Unsupported file format</span>;
    }
  };

  return (
    <div className="w-full">
      <div className={mainTable.mainContentScreen}>
        <div className="flex justify-center">
          <form className="overflow-auto p-5 lg:h-96 md:min-h-[60vh] md:max-h-[60vh] min-h-fit max-h-fit sm:min-h-fit sm:max-h-fit">
            <div className="w-full space-y-4">
              <div className="flex">
                <label className="w-20 font-semibold">To</label>
                <label>: {data?.PartnerName}</label>
              </div>
              <div className="flex">
                <label className="w-20 font-semibold">CC</label>
                <label>: {data2?.CC}</label>
              </div>
              <div className="flex">
                <label className="w-20 font-semibold">BCC</label>
                <label>: {data2?.BCC},{data?.MstCompanyNames}</label>
              </div>

              <div className="flex items-center">
                <label className="w-20 font-semibold">File</label>
                <span className="mr-2">:</span>
                {renderFilePreview()}
              </div>
            </div>
          </form>
        </div>


      </div>

      {/* Preview Modal */}
      {showFileModal && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
          onClick={() => setShowFileModal(false)}
        >
          <div
            className="bg-white p-6 rounded shadow-lg max-w-4xl w-full h-full relative"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setShowFileModal(false)}
              className="absolute top-2 right-2 text-gray-500 hover:text-black text-xl"
            >
              ✕
            </button>
            {previewUrl ? (
              isPdf || isWord || isExcel || isPPT ? (
                <iframe
                  src={getViewerUrl(previewUrl)}
                  title="File Viewer"
                  className="w-full h-[80vh] rounded"
                />
              ) : isImage ? (
                <img
                  src={previewUrl}
                  alt="Preview"
                  className="w-full h-auto max-h-[80vh] object-contain rounded"
                />
              ) : (
                <p className="text-center text-gray-600">
                  Preview not available for this file type.
                </p>
              )
            ) : (
              <p className="text-center text-gray-600">
                No file selected or file not available.
              </p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default AssessmentReportPopup;
